// @flow
import React from 'react';
import { Button } from 'sarsaparilla';
import type { aggregateResponse } from '../../model/aggregate';
import StarDisplay from '../StarDisplay';

type PropTypes = {
  aggregate: ?aggregateResponse,
  wrapper: 'div' | 'li',
};

export default class RatingSummary extends React.PureComponent<PropTypes> {
  static defaultProps = {
    wrapper: 'div',
  };
  render() {
    const { aggregate, wrapper: Tag } = this.props;
    if (!aggregate || !aggregate.number_of_ratings) {
      return null;
    }
    return (
      <Tag className="ratReview-rating-summary-wrapper">
        <Button
          appearance="link"
          onClick={() =>
            document
              .getElementById('rating-review-inventory-review-section-heading')
              .scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        >
          <StarDisplay value={aggregate.average_rating} />
          <span className="ratview-star-value">
            {`${aggregate.number_of_ratings} Review${aggregate.number_of_ratings > 1 ? 's' : ''}`}
          </span>
        </Button>
      </Tag>
    );
  }
}
